/**
 * @link      https://karmabunny.com.au
 * @copyright Copyright (c) 2022 Karmabunny
 */

import { SearchParams } from "./store/book";


const DAY = 24 * 60 * 60 * 1000;


export function addDays(date: Date, days: number): Date {
    return new Date(date.getTime() + DAY * days);
}


export function formatISO(date: Date): string
{
    return (
        date.getFullYear() +
        '-' + ('' + (date.getMonth() + 1)).padStart(2, '0') +
        '-' + ('' + date.getDate()).padStart(2, '0')
    );
}


export function toSearchQuery(search: Partial<SearchParams>) {
    const params = new URLSearchParams();

    if (search.categoryId) {
        params.set('categoryId', '' + search.categoryId);
    }

    if (search.dates) {
        params.set('dateFrom', formatISO(search.dates.start));
        params.set('dateTo', formatISO(search.dates.end));
    }

    if (search.guests) {
        params.set('adults', '' + search.guests.adults);
        params.set('children', '' + search.guests.children);
    }

    return params.toString();
}
